export interface AppIdentity {
  name: string;
  tagline: string;
  description: string;
  iconPath: string;
}

/** Shared product identity for the application shell and home pages. */
export const appIdentity: AppIdentity = {
  name: 'Commons Foundry',
  tagline: 'Helping people make better use of the places and resources they share on our planet.',
  description: 'Plan time together, find and book shared spaces, and make informed choices about the places and resources already available.',
  iconPath: '/commons-mark.svg'
};
